export const BREADCRUMB_TYPE_HIDDEN = Symbol();
